.footer {
  display: flex;
  flex-direction: row;
  align-self: center;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
}

.footerColumn {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 5px;
}

.badgeWrapper {
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.privacyLink {
  color: #115ea3;
  font-size: 10px;
}

.privacyLink:visited {
  color: #115ea3;
}

.exportContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.conversationId {
  font-size: 10px;
}
